import { useEffect, useState } from "react";
import styles from "./leasesignsuccess.module.css";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";
import { Background, Parallax } from 'react-parallax';
import { Link as Linkto, useHistory } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";

const LeaseSignSuccess = ({ history, match }) => {
    const { str } = match.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(true);
    const [propertyDetails, setPropertyDetails] = useState(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/property-details/" + str).then((response) => {
                setLoading(false);

                setPropertyDetails(response.data.data);
            }).catch((error) => {
                redirect.push('/rental-application-invalid');

                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
            });
        }
        if (str)
            fetchTemplates();
    }, [str]);

    return (<>
        {loading && <Loader />}
        <Helmet title="Offer" />

        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">
            <div className={`${styles.RentalAppliArea}`}>
                <div className={`${styles.RentalAppliSuccessSec}`}>
                    <div className={`${styles.SuccessImgSec}`}>
                        <iframe className={`${styles.First}`} src="https://lottie.host/embed/b24214a2-b69d-4f28-84f2-10bdd2aa650f/sV94qG0JEO.lottie"></iframe>
                    </div>
                    <p className={`${styles.PaymentSuccessTitle}`}>Thank You!</p>
                    <p className={`${styles.PaymentSuccessTitleSub}`}>Your lease has been successfully signed. Your renewal is now confirmed.</p>
                </div>
            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: ${propertyDetails?.email}`}>{propertyDetails?.email}</a></li>
                                <li><a href={`tel: ${propertyDetails?.phone}`} >{propertyDetails?.phone}</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </>)
}

export default LeaseSignSuccess;